import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AssistantApi, InventoryResult } from '../api/AssistantApi';
import DailySalesChart from './DailySalesChart';

const today = () => { const now = new Date(); return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`; };
export default function DailySalesPanel({ companyId, depositId, onClose }: { companyId: string; depositId: string; onClose: () => void }) {
  const { t } = useTranslation();
  const [from, setFrom] = useState(() => today().slice(0, 8) + '01');
  const [to, setTo] = useState(today);
  const [data, setData] = useState<InventoryResult>();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const request = useRef<AbortController | null>(null);
  useEffect(() => () => request.current?.abort(), []);
  const valid = !!from && !!to && from <= to && (Date.parse(to) - Date.parse(from)) / 86400000 <= 92;
  return <section className="daily-sales-panel">
    <h3>{t('dailySales.title')}</h3><p>{t('dailySales.rangeHelp')}</p>
    <form onSubmit={event => {
      event.preventDefault(); if (!valid) return;
      request.current?.abort(); const controller = new AbortController(); request.current = controller;
      setBusy(true); setError(false); setData(undefined);
      AssistantApi.dailySales({ companyId: companyId ? Number(companyId) : undefined, depositId: depositId ? Number(depositId) : undefined, from, to }, controller.signal)
        .then(response => { if (!controller.signal.aborted) setData(response.data); })
        .catch(() => { if (!controller.signal.aborted) setError(true); })
        .finally(() => { if (!controller.signal.aborted) setBusy(false); });
    }}>
      <label>{t('chat.fields.from')}<input type="date" value={from} onChange={event => { setData(undefined); setFrom(event.target.value); }} required disabled={busy} /></label>
      <label>{t('chat.fields.to')}<input type="date" value={to} onChange={event => { setData(undefined); setTo(event.target.value); }} required disabled={busy} /></label>
      <button type="submit" disabled={!valid || busy}>{t(busy ? 'chat.loading' : 'dailySales.show')}</button>
    </form>
    {error && <p role="alert">{t('dailySales.failed')}</p>}
    {data && <DailySalesChart data={data} />}
    <button type="button" onClick={onClose}>{t('import.back')}</button>
  </section>;
}
